<template>
    <div
        class="modal fade action-sheet"
        :class="{ inset: inset }"
        tabindex="-1"
        role="dialog"
    >
        <div
            class="modal-dialog"
            :class="fullDisplay ? 'h-100' : ''"
            role="document"
        >
            <div class="modal-content" :class="fullDisplay ? 'h-100' : ''">
                <div class="modal-header" v-if="header">
                    <h5
                        class="modal-title"
                        :style="
                            !btnClose
                                ? 'text-align: center;'
                                : 'text-align: left;'
                        "
                    >
                        {{ title }}
                    </h5>
                    <button
                        type="button"
                        class="close"
                        @click="$emit('close')"
                        v-if="btnClose"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div
                        class="action-sheet-content"
                        :class="[
                            contentFull ? 'p-0' : '',
                            contentHeight ? 'mh-100' : '',
                        ]"
                        :style="
                            fullDisplay ? 'max-height: calc(100vh - 0px);' : ''
                        "
                    >
                        <slot></slot>
                    </div>
                </div>
                <div class="modal-footer" v-if="footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: {
                type: String,
                required: true,
            },
            header: {
                type: Boolean,
                required: false,
                default: true,
            },
            btnClose: {
                type: Boolean,
                required: false,
                default: false,
            },
            inset: {
                type: Boolean,
                required: false,
                default: true,
            },
            contentFull: {
                type: Boolean,
                required: false,
                default: false,
            },
            contentHeight: {
                type: Boolean,
                required: false,
                default: false,
            },
            fullDisplay: {
                type: Boolean,
                required: false,
                default: false,
            },
            footer: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
    };
</script>
